import React from "react";
import { TickFilledIcon } from "./Icons/TickFilledIcon";

interface RadioBtnProps {
  label: string;
  selected: boolean;
  onSelect: (newState: boolean) => void;
  className?: string;
  size?: "default" | "small" | "large";
}

const RadioBtn: React.FC<RadioBtnProps> = ({
  label,
  selected,
  onSelect,
  className = "",
  size = "default",
}) => {
  return (
    <div
      className={`radio-btn radio-btn--${size} ${selected ? "active" : ""} ${className}`}
      onClick={() => onSelect(!selected)} 
    >
      {selected && <TickFilledIcon />}
      <div className="radio-btn__text">{label}</div>
    </div>
  );
};

export default RadioBtn;